var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtendedMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3a2 2 0 104 0 2 2 0 00-4 0m0 8a2 2 0 104 0 2 2 0 00-4 0m0 8a2 2 0 104 0 2 2 0 00-4 0",
    fill: "#777",
    fillRule: "evenodd"
  })));
}
export default SvgExtendedMenu;